import { Path, Shape } from "three";
import {
	type ThreeInputLinesType,
	ThreeShapeSideTypes,
	type ThreeSidePathsType,
} from "../../../../../types/three";
import type { DimensionProperties } from "../../../../../types/workpiece";
import type InputType from "../../../Input/InputType";
import { JsonInputType } from "../../../Input/JsonInputType";
import { SideName } from "../../../Side/SideName";
import Triangle from "../Triangle";

export default class Symmetrical extends Triangle {
	public static code = "plate_triangle_symmetrical";

	public calculateSideLength(side: SideName, input: InputType) {
		const width = Number(input[JsonInputType.Basis]);
		const height = Number(input[JsonInputType.Height]);

		if (!(Number.isNaN(width) || Number.isNaN(height))) {
			switch (side) {
				case SideName.Basis:
					return width;
				case SideName.Width1:
				case SideName.Width2:
					return Math.sqrt(height ** 2 + (width / 2) ** 2);
			}
		}

		return undefined;
	}
	public getThreeShape(props: DimensionProperties["plate_triangle_symmetrical"]) {
		const [length, width] = [props.length / 1000, props.width / 1000];

		return new Shape()
			.moveTo(0, 0)
			.lineTo(length, 0)
			.lineTo(length / 2, width)
			.lineTo(0, 0);
	}

	public getThreeSidePaths(
		props: DimensionProperties["plate_triangle_symmetrical"],
	): ThreeSidePathsType[] {
		const [length, width] = [props.length / 1000, props.width / 1000];

		return [
			{
				path: new Path().moveTo(0, 0).lineTo(length, 0),
				code: "length2",
				type: ThreeShapeSideTypes.side,
			},
			{
				path: new Path().moveTo(length, 0).lineTo(length / 2, width),
				code: "width2",
				type: ThreeShapeSideTypes.side,
			},
			{
				path: new Path().moveTo(length / 2, width).lineTo(0, 0),
				code: "width1",
				type: ThreeShapeSideTypes.side,
			},
		];
	}

	public getThreeInputLines(
		props: DimensionProperties["plate_triangle_symmetrical"],
	): ThreeInputLinesType[] {
		const [length, width] = [props.length / 1000, props.width / 1000];

		return [
			{
				dimension: props.length,
				code: "length",
				path: new Path().moveTo(0, 0).lineTo(length, 0),
				type: ThreeShapeSideTypes.side,
			},
			{
				dimension: props.width,
				code: "width",
				path: new Path().moveTo(0, 0).lineTo(0, width),
				type: ThreeShapeSideTypes.side,
			},
		];
	}

	public getDimensions(props: DimensionProperties["plate_triangle_symmetrical"]) {
		return {
			width: props.width ? props.width : 1000,
			length: props.length ? props.length : 2000,
		};
	}
}
